import styled from 'styled-components';

const CookingStyle = styled.section`
	--cookingRelatedProductContainerDistance: var(--sp13x);
	--cookingDescMTop: var(--sp6x);
	--cookingBtnMTop: var(--sp7x);
	--cookingRelatedProductItemsDistance: var(--sp9x);
	--cookingRelatedProductItemsGap: var(--sp4x);
	--cookingRelatedProductItemWidth: calc((100% / 5) - (4 * var(--cookingRelatedProductItemsGap) / 5));
	--relatedProductItemMTop: var(--sp20x);

	--cookingRelatedProductItemBorderRadius: var(--sp3x);
	--cookingRelatedProductItemBottomContentPadTB: var(--sp4x);
	--cookingRelatedProductItemBottomContentPadLR: var(--sp3x);
	--cookingRelatedProductItemBottomContentGap: var(--sp2x);

	--cookingRelatedProductItemImageSize: 88.1%;

	background-color: var(--green1000);
	padding: var(--sectionDistance) 0;
	overflow: hidden;

	.banner-text {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.button-wrap-link {
		width: fit-content;
		height: fit-content;
		transform: scale(0);
	}

	.cooking-inner-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.styled-text,
	.normal-text {
		color: var(--white1000);
	}

	.cooking-description {
		margin-top: var(--cookingDescMTop);
		text-align: center;
	}

	.cooking-btn {
		margin: 0 auto;
		margin-top: var(--cookingBtnMTop);
	}

	.cooking-product-related-wrapper {
		margin-top: var(--cookingRelatedProductItemsDistance);
	}

	.cooking-product-related-inner-wrapper {
		display: flex;
		flex-wrap: wrap;
		gap: var(--cookingRelatedProductItemsGap);
	}

	.related-product-wrapper {
		width: var(--cookingRelatedProductItemWidth);
		height: fit-content;
		overflow: hidden;
		border-radius: var(--cookingRelatedProductItemBorderRadius);

		&:nth-child(even) {
			margin-top: var(--relatedProductItemMTop);
		}

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					.image-cont {
						transform: scale(1.1);
					}
				}
			}
		}
	}

	.related-product-info-wrapper {
		padding: var(--cookingRelatedProductItemBottomContentPadTB) var(--cookingRelatedProductItemBottomContentPadLR);
		background-color: var(--green100);
	}

	.related-product-info-inner-wrapper {
		display: flex;
		flex-direction: column;
		gap: var(--cookingRelatedProductItemBottomContentGap);
	}

	.related-product-image-wrapper {
		overflow: hidden;
		isolation: isolate;
		backface-visibility: visible;
	}

	.image-cont {
		--proportion: var(--cookingRelatedProductItemImageSize);

		will-change: transform;
		transition: transform 0.4s ease-out;
	}

	.item {
		position: relative;
	}
	.item-1 {
	}
	.item-2 {
		z-index: 6;
	}
	.item-3 {
		z-index: 1;
	}
	.item-4 {
		z-index: 0;
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--cookingRelatedProductContainerDistance: var(--sp10x);

		--cookingDescMTop: var(--sp4x);
		--cookingBtnMTop: var(--sp5x);
		--cookingRelatedProductItemsDistance: var(--sp5x);
		--cookingRelatedProductItemsGap: var(--sp4x);
		--relatedProductItemMTop: var(--sp10x);

		--cookingRelatedProductItemBorderRadius: var(--sp2x);
		--cookingRelatedProductItemBottomContentPadTB: var(--sp3x);
		--cookingRelatedProductItemBottomContentPadLR: var(--sp2-5x);
		--cookingRelatedProductItemBottomContentGap: var(--sp1-5x);

		--cookingRelatedProductItemImageSize: 87.8%;
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--cookingRelatedProductContainerDistance: 60px;
		--cookingDescMTop: var(--sp3x);
		--cookingBtnMTop: var(--sp4x);
		--cookingRelatedProductItemsDistance: var(--sp5x);
		--cookingRelatedProductItemsGap: var(--sp2-5x);
		--relatedProductItemMTop: 60px;

		--cookingRelatedProductItemBorderRadius: var(--sp2x);
		--cookingRelatedProductItemBottomContentPadTB: var(--sp2-5x);
		--cookingRelatedProductItemBottomContentPadLR: var(--sp2x);
		--cookingRelatedProductItemBottomContentGap: var(--sp0-5x);

		--cookingRelatedProductItemImageSize: 87.3%;
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--cookingRelatedProductContainerDistance: 52px;
		--cookingDescMTop: var(--sp3x);
		--cookingBtnMTop: var(--sp4x);
		--cookingRelatedProductItemsDistance: var(--sp4x);
		--cookingRelatedProductItemsGap: var(--sp2x);
		--relatedProductItemMTop: 52px;

		--cookingRelatedProductItemBorderRadius: var(--sp2x);
		--cookingRelatedProductItemBottomContentPadTB: var(--sp2x);
		--cookingRelatedProductItemBottomContentPadLR: var(--sp1-5x);
		--cookingRelatedProductItemBottomContentGap: var(--sp0-5x);

		--cookingRelatedProductItemImageSize: 87.3%;
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--cookingRelatedProductContainerDistance: var(--sp6x);
		--cookingDescMTop: var(--sp2-5x);
		--cookingBtnMTop: var(--sp4x);
		--cookingRelatedProductItemsDistance: var(--sp4x);
		--cookingRelatedProductItemsGap: var(--sp2x);
		--relatedProductItemMTop: var(--sp6x);

		--cookingRelatedProductItemBorderRadius: var(--sp1-5x);
		--cookingRelatedProductItemBottomContentPadTB: var(--sp2x);
		--cookingRelatedProductItemBottomContentPadLR: var(--sp1-5x);
		--cookingRelatedProductItemBottomContentGap: var(--sp0-5x);

		--cookingRelatedProductItemImageSize: 87.3%;
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--cookingRelatedProductContainerDistance: var(--sp6x);
		--cookingDescMTop: var(--sp2-5x);
		--cookingBtnMTop: var(--sp2-5x);
		--cookingRelatedProductItemsDistance: var(--sp4x);
		--cookingRelatedProductItemsGap: var(--sp2-5x);
		--cookingRelatedProductItemWidth: calc((100% / 3) - (2 * var(--cookingRelatedProductItemsGap) / 3));
		--relatedProductItemMTop: unset;

		--cookingRelatedProductItemBorderRadius: var(--sp1-5x);
		--cookingRelatedProductItemBottomContentPadTB: var(--sp2x);
		--cookingRelatedProductItemBottomContentPadLR: var(--sp2x);
		--cookingRelatedProductItemBottomContentGap: var(--sp1x);

		--cookingRelatedProductItemImageSize: 87.3%;

		.cooking-product-related-inner-wrapper {
			display: grid;
			grid-template-columns: repeat(3, 1fr);
		}

		.related-product-wrapper {
			width: 100%;
		}

		.item-1 {
			--relatedProductItemMTop: var(--sp24x);

			grid-area: 1/2/3/3;
		}
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--cookingRelatedProductContainerDistance: var(--sp5x);
		--cookingDescMTop: var(--sp2x);
		--cookingBtnMTop: var(--sp3x);
		--cookingRelatedProductItemsDistance: var(--sp1-5x);
		--cookingRelatedProductItemsGap: var(--sp2x);
		--relatedProductItemMTop: unset;

		--cookingRelatedProductItemBorderRadius: var(--sp1x);
		--cookingRelatedProductItemBottomContentPadTB: var(--sp2x);
		--cookingRelatedProductItemBottomContentPadLR: var(--sp2x);
		--cookingRelatedProductItemBottomContentGap: var(--sp0-5x);

		--cookingRelatedProductItemImageSize: 87.3%;

		.item-1 {
			--relatedProductItemMTop: var(--sp13x);
		}
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--cookingRelatedProductContainerDistance: var(--sp4x);
		--cookingDescMTop: var(--sp2x);
		--cookingBtnMTop: var(--sp3x);
		--cookingRelatedProductItemsDistance: var(--sp2-5x);
		--cookingRelatedProductItemsGap: var(--sp1x);
		--cookingRelatedProductItemWidth: calc((100% / 2) - (1 * var(--cookingRelatedProductItemsGap) / 2));
		--relatedProductItemMTop: unset;

		--cookingRelatedProductItemBorderRadius: var(--sp1x);
		--cookingRelatedProductItemBottomContentPadTB: var(--sp1x);
		--cookingRelatedProductItemBottomContentPadLR: var(--sp1x);
		--cookingRelatedProductItemBottomContentGap: var(--sp0-5x);

		--cookingRelatedProductItemImageSize: 87.3%;

		.cooking-product-related-inner-wrapper {
			grid-template-columns: repeat(2, 1fr);
		}

		.item-0 {
			grid-area: 1/1/3/2;
		}

		.item-1 {
			--relatedProductItemMTop: 0;

			grid-area: 2/2/4/3;
		}

		.item-2 {
			grid-area: 3/1/5/2;
		}

		.item-3 {
			grid-area: 4/2/6/3;
		}

		.item-4 {
			grid-area: 5/1/7/2;
		}
	}
`;

export default CookingStyle;
